import luckyDrawAvailableItem from '@/api/lucky-draw/lucky-draw-available-item'

import { baseState, baseMutations } from '@/store/mixins'
import { split } from 'lodash';

export const state = {
	...baseState,
	formViewData: []
}

export const getters = {
	getItem: state => ({ chosenItem, search = '' } = {}) => {
		if (chosenItem !== undefined) {
			return (
				state.formViewData.luckyDrawItems
					.filter(p =>
						!_.includes(chosenItem.map(el => el.item_id), p.item_id)
					)
					.filter(p =>
						search.split(' ').every((s) => p.item_name_en.toLowerCase().includes(s.toLowerCase())) ||
						search.split(' ').every((s) => p.item_name_kh.toLowerCase().includes(s.toLowerCase()))
					)
					.slice(0, 100)
			)
			// return state.products.filter(p => search.split(' ').every((s) => p.product_name_en.includes(s)));
		}
		return state.formViewData.luckyDrawItems.slice(0, 100);
	},
	findItem: state => itemId => {
		if (!itemId) {
			return {
				item_name_en: null,
				item_name_kh: null
			}
		}
		return state.formViewData.luckyDrawItems.find(p => p.item_id == itemId)
	},
}

export const mutations = {
	...baseMutations,
	SET_VIEW_MODELS(state, { data, index }) {
		if (!index) {
			state.formViewData = data;
		} else {
			split(index, ",").forEach(el => {
				state.formViewData[el] = data[el];
			});
		}
	},
}

export const actions = {
	fetch(context, attrubutes = {}) {
		let params = Object.assign(
			{
				page: context.state.pagination.page,
				perPage: context.state.pagination.perPage,
				filter: {
					search: context.state.search
				}
			},
			attrubutes
		)
		return luckyDrawAvailableItem.get({ params }).then(response => {
			context.commit('RECEIVE_RESOURCES', response)
			return Promise.resolve(response)
		})
	},
	store(context, data) {
		return luckyDrawAvailableItem.store(data)
	},
	update(context, { id, data }) {
		return luckyDrawAvailableItem.update(id, data)
	},
	changeIsActive(context, { id, data }) {
		return luckyDrawAvailableItem.changeIsActive(id, data)
	},
	async find(context, id) {
		if (_.isEmpty(context.state.edit_data)) {
			let response = await luckyDrawAvailableItem.find(id)
			context.commit('SET_EDIT_DATA', response.data)
		}
	},
	destroy(context, id) {
		return luckyDrawAvailableItem.destroy(id)
	},
	async getFormViewData(context, { params, index }) {
		let response = await luckyDrawAvailableItem.formModel({ params: params });
		context.commit("SET_VIEW_MODELS", {
			data: response.data,
			index: index
		});
		return Promise.resolve(response);
	},
}
